import React from 'react';

const PageContainer = ({ children, className = '', size = 'default' }) => {
  const sizeClasses = {
    small: 'max-w-3xl',      // 768px - for focused content
    default: 'max-w-[1200px]', // 1200px - standard pages
    large: 'max-w-7xl',       // 1280px - search, listings
    full: 'max-w-full'        // 100% - full width
  };

  return (
    <div className={`w-full ${sizeClasses[size]} mx-auto px-4 sm:px-6 lg:px-8 ${className}`}>
      {children}
    </div>
  );
};

export default PageContainer;
